import { render, staticRenderFns } from "./UserChooser.vue?vue&type=template&id=24dd0276&scoped=true&"
import script from "./UserChooser.vue?vue&type=script&lang=js&"
export * from "./UserChooser.vue?vue&type=script&lang=js&"
import style0 from "./UserChooser.vue?vue&type=style&index=0&id=24dd0276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd0276",
  null
  
)

export default component.exports